import { useLiveQuery } from 'dexie-react-hooks';
import db from '@/db/db';
import { SelectedPerson } from '@/db/types/user';

/**
 * Hook to reactively load and access the current person from Dexie
 * Provides organizationId for convenient filtering
 * Automatically updates when the current person changes in the database
 */
export function useCurrentPerson() {
  const currentPerson = useLiveQuery(
    async () => {
      const item = await db.applicationSession.get('current_person');
      return item?.value ? (item.value as SelectedPerson) : null;
    },
    []
  );

  return {
    currentPerson: currentPerson ?? null,
    organizationId: currentPerson?.organization?.id ?? null,
    loading: currentPerson === undefined
  };
}
